<template>
  <main id="main">
    <div class="w-100 bg-success d-flex flex-column justify-content-center align-items-center" style="height: 100dvh">
        <section
                class="w-80 p-3 position-relative bg-white rounded-5 shadow d-flex flex-column justify-content-end align-items-center row-gap-4"
                style="height: 40vh;">
            <img src="@/assets/imgs/Sucssue.svg" alt="" class="position-absolute"
                 style="top: -75px;width: 35%;  filter: drop-shadow(3px 5px 10px rgba(0, 0, 0, 0.5));">
            <span class="font_normal bold w-100 text-center text-success">ارسال موفق</span>
            <textarea rows="5" class="w-100 rounded-5 shadow">

            </textarea>
            <button class="button" @click="$router.go(-1)">فهمیدم</button>
        </section>
    </div>
  </main>
</template>

<script>
export default {
  name: 'AttachReport'
}
</script>

<style scoped>
</style>